<!-- AdminViewImage.vue -->
<template>
  <main class="admin-shot">
    <!-- NOTE: requestID, not request-id -->
    <ScreenshotViewer :requestID="requestID" mode="admin" />
  </main>
</template>

<script>
import ScreenshotViewer from './ScreenshotViewer.vue';

export default {
  name: 'AdminViewImage',
  components: { ScreenshotViewer },
  props: {
    requestID: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped>
.admin-shot {
  padding: 1rem;
}
</style>
